/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosTrxBalanceChangeInfo = {
    ADDR: string;
    EVT: string;
    CHAMG: string;
    CID: string;
    ASNM: string;
    ASSB: string;
    PST: AptosTrxBalanceChangeInfo.PST;
};

export namespace AptosTrxBalanceChangeInfo {

    export enum PST {
        VERIFIED = 'VERIFIED',
        RECOGNIZED = 'RECOGNIZED',
        UNVERIFIED = 'UNVERIFIED',
        BANNED = 'BANNED',
        INTERNAL_FA = 'INTERNAL_FA',
        LP = 'LP',
        NONE = 'NONE',
    }


}

